import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LoginPage from '@/pages/LoginPage';
import DashboardLayout from '@/components/DashboardLayout';
import Dashboard from '@/pages/Dashboard';
import ProductsEnhanced from '@/pages/ProductsEnhanced';
import SuppliersEnhanced from '@/pages/SuppliersEnhanced';
import Onboarding from '@/pages/Onboarding';
import OGOnboarding from '@/pages/OGOnboarding';
import OGProductPublishing from '@/pages/OGProductPublishing';
import PurchaseOrders from '@/pages/PurchaseOrders';
import POApprovalDashboard from '@/pages/POApprovalDashboard';
import GRNManagement from '@/pages/GRNManagement';
import GRNDashboard from '@/pages/GRNDashboard';
import GRNCreatePage from '@/pages/GRNCreatePage';
import GRNBulkUploadPage from '@/pages/GRNBulkUploadPage';
import VendorMismatchReport from '@/pages/VendorMismatchReport';
import SalesOrders from '@/pages/SalesOrders';
import SalesOrdersDashboard from '@/pages/SalesOrdersDashboard';
import StockAudit from '@/pages/StockAudit';
import StockAuditSession from '@/pages/StockAuditSession';
import StockLedger from '@/pages/StockLedger';
import AdminSettings from '@/pages/AdminSettings';
import OrderControlPanel from '@/pages/OrderControlPanel';
import ProductDiagnose from '@/pages/ProductDiagnose';
import InventoryDashboard from '@/pages/InventoryDashboard';
import InventoryStockList from '@/pages/InventoryStockList';
import VendorPaymentSummary from '@/pages/VendorPaymentSummary';
import CreditNotes from '@/pages/CreditNotes';
import POGRNAnalytics from '@/pages/POGRNAnalytics';
import SalesAnalytics from '@/pages/SalesAnalytics';
import DebitNotes from '@/pages/DebitNotes';
import InvoiceEditHistory from '@/pages/InvoiceEditHistory';
import DeliveryChallanEditHistory from '@/pages/DeliveryChallanEditHistory';
import InventoryBatches from '@/pages/InventoryBatches';
import StockAdjustment from '@/pages/StockAdjustment';
import LowStockReport from '@/pages/LowStockReport';
import InvoiceDashboard from '@/pages/InvoiceDashboard';
import InvoiceCreate from '@/pages/InvoiceCreate';
import DeliveryChallan from '@/pages/DeliveryChallan';
import Orders from '@/pages/Orders';
import OGOrders from '@/pages/OGOrders';
import ServiceArea from '@/pages/ServiceArea';
import OGCategoryPublishing from '@/pages/OGCategoryPublishing';
import OGOffersPublishing from '@/pages/OGOffersPublishing';
import ProductRequests from '@/pages/ProductRequests';
import PurchaseReturns from '@/pages/PurchaseReturns';
import Reports from '@/pages/Reports';
import SalesFulfillmentReport from '@/pages/SalesFulfillmentReport';
import AllGRNReport from '@/pages/AllGRNReport';
import AllFranchiseeOrdersReport from '@/pages/AllFranchiseeOrdersReport';
import FulfillmentVarianceReport from '@/pages/FulfillmentVarianceReport';
import FranchisePerformance from '@/pages/FranchisePerformance';
import StoreLogin from '@/pages/store/StoreLogin';
import StoreChangePassword from '@/pages/store/StoreChangePassword';
import StoreCatalogue from '@/pages/store/StoreCatalogue';
import StoreCart from '@/pages/store/StoreCart';
import StoreOrders from '@/pages/store/StoreOrders';
import StoreInvoices from '@/pages/store/StoreInvoices';
import StoreProductRequests from '@/pages/store/StoreProductRequests';
import StoreDashboard from '@/pages/store/StoreDashboard';
import AiAssistant from '@/pages/AiAssistant';
import '@/App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="text-lg font-medium text-slate-700">Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={!user ? <LoginPage setUser={setUser} /> : <Navigate to="/" />}
          />
          <Route
            path="/"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <Dashboard />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/products"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <ProductsEnhanced />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/suppliers"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <SuppliersEnhanced />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/onboarding"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <Onboarding />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/og-onboarding"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <OGOnboarding />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/og-publishing"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <OGProductPublishing />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/customers"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <Onboarding />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/purchase-orders"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <PurchaseOrders />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/po-approvals"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <POApprovalDashboard />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/grn"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <GRNManagement />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/grn-dashboard"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <GRNDashboard />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/grn/create"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <GRNCreatePage />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/grn/bulk-upload"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <GRNBulkUploadPage />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/vendor-mismatch"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <VendorMismatchReport />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/purchase-returns"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <PurchaseReturns />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/delivery-challans"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <DeliveryChallan />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/orders"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <Orders />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/og-orders"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <OGOrders />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/og-service-area"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <ServiceArea />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/og-category-publishing"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <OGCategoryPublishing />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/og-offers-publishing"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <OGOffersPublishing />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/product-requests"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <ProductRequests />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/sales-orders"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <SalesOrders />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/sales-orders/dashboard"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <SalesOrdersDashboard />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/stock-audit"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <StockAudit />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/stock-audit/sessions/:id"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <StockAuditSession />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/stock-ledger"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <StockLedger />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/reports"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <Reports />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/reports/fulfillment-variance"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <FulfillmentVarianceReport />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/reports/all-franchisee-orders"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <AllFranchiseeOrdersReport />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/reports/all-grn"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <AllGRNReport />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/reports/sales-analytics"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <SalesAnalytics />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/reports/po-grn-analytics"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <POGRNAnalytics />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/reports/sales-fulfillment"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <SalesFulfillmentReport />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/franchise-performance"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <FranchisePerformance />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/inventory"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <InventoryDashboard />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/inventory/stock-list"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <InventoryStockList />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/assistant"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <AiAssistant />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/accounts/vendor-payments"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <VendorPaymentSummary />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/accounts/credit-notes"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <CreditNotes />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/accounts/debit-notes"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <DebitNotes />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/accounts/invoice-edits"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <InvoiceEditHistory />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/accounts/dc-edits"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <DeliveryChallanEditHistory />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/inventory/adjustment"
            element={
              user && user.role === 'admin' ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <StockAdjustment />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/inventory/low-stock"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <LowStockReport />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/inventory/batches"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <InventoryBatches />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/invoices"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <InvoiceDashboard />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/invoices/create"
            element={
              user ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <InvoiceCreate />
                </DashboardLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/admin-settings"
            element={
              user && user.role === 'admin' ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <AdminSettings />
                </DashboardLayout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/order-control"
            element={
              user && (user.role === 'admin' || user.role === 'manager') ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <OrderControlPanel />
                </DashboardLayout>
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* Hidden admin diagnostic — NOT linked in nav. Typed URL only.
              Accepts /admin/diagnose (lookup form) or /admin/diagnose/SKU. */}
          <Route
            path="/admin/diagnose"
            element={
              user && (user.role === 'admin' || user.role === 'manager') ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <ProductDiagnose />
                </DashboardLayout>
              ) : (<Navigate to="/" />)
            }
          />
          <Route
            path="/admin/diagnose/:sku"
            element={
              user && (user.role === 'admin' || user.role === 'manager') ? (
                <DashboardLayout user={user} onLogout={handleLogout}>
                  <ProductDiagnose />
                </DashboardLayout>
              ) : (<Navigate to="/" />)
            }
          />

          {/* Store / Franchise Self-Service Portal */}
          <Route path="/store/login" element={<StoreLogin />} />
          <Route path="/store/change-password" element={<StoreChangePassword />} />
          <Route path="/store" element={<Navigate to="/store/dashboard" replace />} />
          <Route path="/store/dashboard" element={<StoreDashboard />} />
          <Route path="/store/catalogue" element={<StoreCatalogue />} />
          <Route path="/store/cart" element={<StoreCart />} />
          <Route path="/store/orders" element={<StoreOrders />} />
          <Route path="/store/invoices" element={<StoreInvoices />} />
          <Route path="/store/product-requests" element={<StoreProductRequests />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
